import { createFileRoute } from "@tanstack/react-router";
import { AgentTokens, ConnectAgent } from "@/components/settings/agent-tokens";
import { useWorkspace } from "@/components/shell/workspace-context";

export const Route = createFileRoute("/_app/$workspaceSlug/settings/agents")({
  component: AgentSettings,
});

/** A person's own agents in this workspace: the tokens they hold, and how to connect one. */
function AgentSettings() {
  const { workspace } = useWorkspace();
  return (
    <>
      <AgentTokens workspaceId={workspace._id} />
      <ConnectAgent />
    </>
  );
}
